import React from "react";
import { NavLink } from "react-router-dom";

const LinkButton = ({ title, to, onClick }) => (
    <NavLink
        title={title}
        onClick={onClick}
        to={{
            pathname: to,
        }}
        className="mdl-button  mdl-button--fab fab-mini"
    >
        <i className="material-icons text-success">add</i>
    </NavLink>
);

export default LinkButton;
